import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Seo from "../components/Seo";
import Hero from "../components/sections/Hero";
import Stats from "../components/sections/Stats";
import Positioning from "../components/sections/Positioning";
import Services from "../components/sections/Services";
import About from "../components/sections/About";
import WhyUs from "../components/sections/WhyUs";
import Process from "../components/sections/Process";
import Portfolio from "../components/sections/Portfolio";
import TargetGroups from "../components/sections/TargetGroups";
import Testimonials from "../components/sections/Testimonials";
import BlogTeaser from "../components/sections/BlogTeaser";
import FAQ from "../components/sections/FAQ";
import CTABand from "../components/sections/CTABand";
import Contact from "../components/sections/Contact";
import useReveal from "../hooks/useReveal";

export default function Home() {
  useReveal();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 80);
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [location]);

  return (
    <main data-testid="home-page" className="bg-[#F8F5EF]">
      <Seo path="/" />
      <Hero />
      <Stats />
      <Positioning />
      <Services />
      <About />
      <WhyUs />
      <Process />
      <Portfolio />
      <TargetGroups />
      <Testimonials />
      <BlogTeaser />
      <FAQ />
      <CTABand />
      <Contact />
    </main>
  );
}
